export const getFirstIncrement = (min: number, step: number) => {
  let start = min;
  if (step > 1 && step > min) {
    start = step;
  } else if (step > 1 && step < min) {
    start = step;
    while (start < min) {
      start += step;
    }
  }

  return start;
};
